const StorageManager = {
  userId:   (val) => val !== undefined ? localStorage.setItem("bw_userId",   String(val)) : localStorage.getItem("bw_userId"),
  username: (val) => val !== undefined ? localStorage.setItem("bw_username", val)        : localStorage.getItem("bw_username"),
  roleName: (val) => val !== undefined ? localStorage.setItem("bw_roleName", val)        : localStorage.getItem("bw_roleName"),

  clear: () => {
    ["bw_userId", "bw_username", "bw_roleName"].forEach((k) => localStorage.removeItem(k));
    sessionStorage.removeItem("bw_token");
  },
};

export default StorageManager;
